<template>
  <div class="mainPage">
    <!--仓单系统  -->
    <div class="typeArea">
      <div class="firstWrap">
        <!-- <div class="oneTit">仓单系统</div> -->
        <div v-for="(item,i) of tabList" :key="i" :class="i==tabIndex?'activeFirst':''" @click="openReport(i)">
          {{ item.name }}
        </div>
      </div>
      <div class="chooseWrap">
        <div class="itemSearch">
          <div class="searchTitle">仓单号</div>
          <div class="searchContent">
            <el-input
              
            size="small" 
              v-model.number="wareCode"
              type="number"
              placeholder="请输入仓单号"
              clearable
            >
            </el-input>
          </div>
        </div>
        <div class="actionSearch">
          <el-button
            class="searchBtn"
            plain
            size="small"
            @click="searchData"
          >查询</el-button>
          <el-button
            class="restBtn"
            size="small"
            @click="restData"
          >重置</el-button>
        </div>
      </div>
      <div class="orderWrap">
        <div class="twoTabContent">
          <!-- 表单内容 -->
          <orderTabFirst v-if="tabIndex==0" :warehouse-id="wareCode" :is-search="isSearch" />
          <orderTabTwo v-if="tabIndex==1" :warehouse-id="wareCode" :is-search="isSearch " />
          <orderTabThree v-if="tabIndex==2" :warehouse-id="wareCode" :is-search="isSearch " />
          <orderTabFour v-if="tabIndex==3" :warehouse-id="wareCode" :is-search="isSearch " />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import orderTabFirst from './warehousTab/orderTabFirst'
import orderTabTwo from './warehousTab/orderTabTwo'
import orderTabThree from './warehousTab/orderTabThree'
import orderTabFour from './warehousTab/orderTabFour'


export default ({
  components: {
    orderTabFirst,
    orderTabTwo,
    orderTabThree,
    orderTabFour

  },
  data() {
    return {
      isSearch: false,
      tabIndex: 0,
      search: {
        time: null,
        radio: 1
      },
      tabList: [
        { name: '可用仓单' },
        { name: '出库申请仓单' },
        { name: '已出库仓单' },
        { name: '物流提货查询' }
      ],
      wareCode: null
    }
  },
  methods: {
    searchData() {
      // 搜索报表
      this.isSearch = true
      setTimeout(() => {
        this.isSearch = false
      }, 1000)
    },
    restData() {
      // 重置报表
      this.wareCode = null
      this.isSearch = true
      setTimeout(() => {
        this.isSearch = false
      }, 1000)
    },
    exportReport() {
      // 导出报表
    },
    openReport(index) {
      this.tabIndex = index
      this.wareCode = null
    },
  }
})
</script>
<style lang="scss">
</style>